/**
 * Create a page for all wpPage nodes automatically via
 * filesystem routing: https://www.gatsbyjs.com/docs/reference/routing/file-system-route-api/
 */
import * as React from "react"
import MainLayout from "../../../layouts/main"
import IPTSCourse from "../../../interfaces/IPTSCourse"
import PtsCourse from "../../../views/pts-course"
import { AUGUST_COURSES } from "../../../api/get-pts-sections"
import NotFoundPage from "../../404"
import { Helmet } from "react-helmet"
import getCrnTerms from "../../../utils/crn-terms-calculator"

interface IPageProps {
  data: {
    ptsCourse: IPTSCourse
  }
}

export default function Page({ serverData }): JSX.Element {
  const course = serverData.data.ptsCourse
  const ssr = serverData.data.ssr
  if (ssr) console.log(`SSR Course`)
  const breadcrumbs = JSON.stringify([
    {
      text: `Home`,
      url: `/`,
      id: 0,
    },
    {
      text: `Academics`,
      url: `/academics`,
      id: 1,
    },
    {
      text: `Continuing Education`,
      url: `/academics/continuing-education/`,
      id: 2,
    },
    {
      text: `Courses`,
      url: `/academics/continuing-education/courses/#filters`,
      id: 3,
    },
    {
      text: course?.Title,
      url: course?.slug,
      id: 4,
    },
  ])

  return course?.outline ? (
    <>
      <Helmet>
        <title>
          {`Study ${course.Title} ${course.Campuses?.length > 0
              ? `in ${course.Campuses.join(`, `)}`
              : ``
            } at Georgian College`}
        </title>
        <meta name="description" content={course.Description} />
      </Helmet>
      <PtsCourse ptsCourse={course} breadcrumbs={breadcrumbs} />
    </>
  ) : serverData.data.Code !== `MARI` ? (
    <>
      <MainLayout localMenuItem={null} breadcrumbs={breadcrumbs}>
        <div className="container max-w-[1232px] mx-auto p-4">
          Sorry that course does not exist. Please check the link and try again.
        </div>
      </MainLayout>
    </>
  ) : (
    <NotFoundPage></NotFoundPage>
  )
}

// configure page, for example set defer to use DSG
// export async function config() {
//   // Optionally use GraphQL here
//   return ({ params }) => {
//     return {
//       defer: true,
//     }
//   }
// }

export async function getServerData({
  params,
}: {
  params: { slug: string }
}): Promise<{ props: IPageProps }> {
  const { slug } = params
  const slugParts = slug.split(`-`)
  const code = slugParts[slugParts.length - 2]?.toUpperCase()
  if (code == `MARI`) {
    return {
      props: {
        data: {
          Campuses: [],
          Categories: null,
          Code: `MARI`,
          Daytime: false,
          Description: ``,
          Equivalents: [],
          Evening: false,
          Number: ``,
          Online: false,
          OntarioLearn: false,
          SectionSeq: ``,
          Title: ``,
          Weekend: false,
        },
      },
    }
  }
  const number = slugParts[slugParts.length - 1]?.toUpperCase()
  const TERM_RANGE = await getCrnTerms() // [`202410`, `203010`]
  const courseCode = `${code}${number}`
  if (AUGUST_COURSES.includes(courseCode)) {
    // get current year
    const currentYear = new Date().getFullYear()
    TERM_RANGE[0] = `${currentYear}20`
    TERM_RANGE[1] = `${currentYear + 6}10`
  }
  const url = `${process.env.PTS_API_URL}/LoadCourseOutline/${code}/${number}/${TERM_RANGE[0]}-${TERM_RANGE[1]}`
  const res = await fetch(url)
  const data = await res.json()
  const course = {
    outline: data.LoadCourseOutlineResult,
    ...(data.LoadCourseOutlineResult?.Overview?.length > 0
      ? data.LoadCourseOutlineResult?.Overview[0]
      : data.LoadCourseOutlineResult),
  }
  // console.log({ data, slug, code, number, url })
  return {
    props: {
      data: {
        ssr: true,
        ptsCourse: course,
      },
    },
  }
}
